import { Modal } from 'src/components/molecules/Modal';
import {
  UpdateReportAssigneeBoldText,
  UpdateReportAssigneeText,
} from './ReassignReportModal.styles';

interface ReassignReportModalProps {
  open: boolean;
  setOpen(open: boolean): void;
  onConfirm(): void;
  onCancel(): void;
}

export const ReassignReportModal = ({
  open,
  setOpen,
  onConfirm,
  onCancel,
}: ReassignReportModalProps) => {
  return (
    <Modal
      title={'Confirm Report Reassignment'}
      setOpen={setOpen}
      open={open}
      onConfirm={onConfirm}
      onCancel={onCancel}
      size={'medium'}
      data-testid={'report-reassignment-modal'}
    >
      <UpdateReportAssigneeText>
        Are you sure you want to reassign the report assignee for this case?
      </UpdateReportAssigneeText>
      <br />
      <UpdateReportAssigneeText>
        By confirming, you are acknowledging that you understand the following:
      </UpdateReportAssigneeText>
      <br />

      <UpdateReportAssigneeText>
        1.{' '}
        <UpdateReportAssigneeBoldText>
          Responsibility Transfer:
        </UpdateReportAssigneeBoldText>{' '}
        The responsibility for this report will be transferred to the new report
        assignee.
      </UpdateReportAssigneeText>

      <UpdateReportAssigneeText>
        2.{' '}
        <UpdateReportAssigneeBoldText>
          Communication:
        </UpdateReportAssigneeBoldText>{' '}
        The new report assignee and the reporter will be notified of this
        reassignment via email and within the system.
      </UpdateReportAssigneeText>

      <UpdateReportAssigneeText>
        3. <UpdateReportAssigneeBoldText>Access:</UpdateReportAssigneeBoldText>{' '}
        The new report assignee will have access to all case-related information
        and data.
      </UpdateReportAssigneeText>
    </Modal>
  );
};
